import { createSelector } from "reselect";
import {
    getUserUidSelector,
    getUserLocale,
    makeSelectAppLoggedIn
} from "../../app/appSelectors";
import {getAbTestLandingPage} from "../AbTests/abTestsSelectors";
import type { IAbTest } from "../../app/types/appActions.t";

 
export const googleTagManageRequiredParamsSelector = createSelector(
    [
        getUserUidSelector,
        getAbTestLandingPage,
        makeSelectAppLoggedIn(),
        getUserLocale,
    ],
    (uid, abTestLandingPage, loggedIn, locale) => {
        const params: {
            uid: number | null;
            loggedIn: boolean;
            locale: string;
            abTests?: IAbTest;
        } = {uid, loggedIn, locale };
        if (abTestLandingPage !== undefined) {
            params.abTests = abTestLandingPage;
        }
        return params;
    }
);
